import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Activity } from 'lucide-react';

export default function ResponseTimeContainerSkeleton() {
    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <Activity className="oct_icon" />
                <h3>Avg Response Time</h3>
            </div>

            <div className="oct_sys-response-time-wrapper-v2">
                <div className="text-center oct_skeleton-flex-col-center-full">
                    <Skeleton variant="text" width={120} height={80} />
                </div>
            </div>
        </div>
    );
}
